import React from 'react';
import { AlertBox, Box } from '@origin-digital/style-guide';

import { AlertBannerProps, AlertBannerState, DisqualifierMessages } from './AlertBanner.types';

// @ts-ignore
import stepOne from '../../apps/SolarContact/components/RequestQuote/meta/stepOne.json';

const { form } = stepOne;

class AlertBanner extends React.Component<AlertBannerProps, AlertBannerState> {
  static disqualifiers: DisqualifierMessages = {
    hiddenPostcode: form.fields.hiddenPostcode.validations.inValidOption.message,
    roofType: form.fields.roofType.validations.validOption.message,
    propertyType: form.fields.propertyType.validations.validOption.message
  };

  static getDerivedStateFromProps(nextProps: AlertBannerProps, prevProps: AlertBannerProps) {
    if (nextProps.hasError === AlertBanner.disqualifiers[nextProps.name]) {
      return { hasError: nextProps.hasError };
    } else return { hasError: undefined };
  }

  constructor(props: AlertBannerProps) {
    super(props);

    this.state = {
      hasError: undefined
    };
  }

  componentDidUpdate(nextProps: AlertBannerProps, prevState: AlertBannerState) {
    const { name, recordDisqualification, message } = this.props;
    const { hasError } = this.state;

    if (recordDisqualification && hasError !== prevState.hasError && hasError !== undefined) {
      recordDisqualification(name, message);
    }
  }

  render(): JSX.Element | null {
    const { heading, message, show } = this.props;

    if (!show) {
      return null;
    }

    return (
      <Box marginBottom={6}>
        <AlertBox type={'error'} data-id="postCodeAlertBox" heading={heading} message={message} />
      </Box>
    );
  }
}

export { AlertBanner as default };
